import { useQuery } from '@tanstack/react-query';
import type { StudentMealMenuDetailsDto } from '../../../models/meal-menus/student/student-has-unpaid-meal-menus.dto';
import apiRequest from '../../../services/apiWrapper';
import { FOOD_PAYMENTS } from '../../../utils/constants/urlConstants';

async function getHasUnpaidFoodTaxes(year: number, studentId: string) {
  const res = await apiRequest.get<StudentMealMenuDetailsDto>(
    `${FOOD_PAYMENTS}/students/has-unpaid?year=${year}&studentId=${studentId}`
  );

  return res.data;
}
export function useGetHasUnpaidFoodTaxes(year: number, studentId: string) {
  return useQuery({
    queryKey: ['has-unpaid-food-taxes', year, studentId],
    queryFn: () => getHasUnpaidFoodTaxes(year, studentId),
    enabled: Boolean(studentId && year > 0),
    throwOnError: false,
    retry: Boolean(studentId && year > 0),
  });
}
